/**
 * Utilitários para gerenciamento de senhas
 * Nota: Este é um hash simples para uso básico, não para alta segurança
 */

/**
 * Gera um hash simples da senha usando uma combinação de técnicas básicas
 * @param password - Senha em texto plano
 * @returns Hash da senha
 */
export const hashPassword = (password: string): string => {
  // Adiciona um salt simples baseado no tamanho da senha
  const salt = password.length.toString();
  const saltedPassword = password + salt;
  
  // Usa uma combinação de técnicas básicas para criar um hash
  let hash = 0;
  for (let i = 0; i < saltedPassword.length; i++) {
    const char = saltedPassword.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Converte para 32bit integer
  }
  
  // Adiciona mais complexidade
  const reversed = saltedPassword.split('').reverse().join('');
  let reverseHash = 0;
  for (let i = 0; i < reversed.length; i++) {
    const char = reversed.charCodeAt(i);
    reverseHash = ((reverseHash << 3) - reverseHash) + char;
    reverseHash = reverseHash & reverseHash;
  }
  
  // Combina os hashes e converte para string hexadecimal
  const combinedHash = Math.abs(hash + reverseHash);
  return combinedHash.toString(16) + salt;
};

/**
 * Verifica se a senha fornecida corresponde ao hash armazenado
 * @param password - Senha em texto plano
 * @param hashedPassword - Hash armazenado
 * @returns true se a senha está correta
 */
export const verifyPassword = (password: string, hashedPassword: string): boolean => {
  const generatedHash = hashPassword(password);
  return generatedHash === hashedPassword;
};

/**
 * Valida se a senha atende aos critérios básicos
 * @param password - Senha para validar
 * @returns Objeto com resultado da validação
 */
export const validatePassword = (password: string): {
  isValid: boolean;
  errors: string[];
} => {
  const errors: string[] = [];
  
  if (!password || password.length < 4) {
    errors.push("A senha deve ter pelo menos 4 caracteres");
  }
  
  if (password.length > 20) {
    errors.push("A senha deve ter no máximo 20 caracteres");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};
